const apiUrl = process.env.REACT_APP_API_URL;

export const getImageUrl = (record: any, fallbackType?: string) => {
    if (!record) return '';
    if (record.imagen && record.imagen.startsWith('data:')) return record.imagen;
    const type = record._type || fallbackType;
    if (!type || !record.id) return '';
    return `${apiUrl}:8061/jutge/game/image/${type}/${record.id}`;
};

export const javamonImage = (record: any) => {
    return getImageUrl(record);
};

export const getBase64 = (file: any): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = error => reject(error);
    });

export const matchesType = (targetType: string, savedType: string) => {
    if (!savedType) return false;
    const t1 = targetType.toLowerCase();
    const t2 = savedType.toLowerCase();
    if (t1 === t2) return true;
    if (t1 === 'escut' && (t2 === 'escudo' || t2 === 'shield')) return true;
    if (t1 === 'arc' && (t2 === 'arco' || t2 === 'bow')) return true;
    if (t1 === 'arma' && t2 === 'weapon') return true;
    if (t1 === 'flecha' && t2 === 'arrow') return true;
    if (t1 === 'magia' && (t2 === 'magic' || t2 === 'ability')) return true;
    return false;
};

export const getItemUsageDetails = (type: string, item: any, rewardsUsage: any) => {
    const itemId = item.id;

    const actividades: { nom: string; problema_nom: string; aula_nom: string; isPractica: boolean }[] = [];
    const practicas: { nom: string; problema_nom: string; aula_nom: string; isPractica: boolean; origen_tipo?: string }[] = [];

    (rewardsUsage?.problemas || []).forEach((p: any) => {
        let matches = false;
        if (type === 'javamon') {
            if (p.tipo === 'JAVAMON' && (p.id_item === itemId || String(p.id_item) === String(itemId))) {
                matches = true;
            }
        } else {
            if (matchesType(type, p.tipo) && (p.id_item === itemId || String(p.id_item) === String(itemId))) {
                matches = true;
            }
        }

        if (matches) {
            const isPrac = p.origen_tipo === 'PRACTICA' || p.practica_tipus === 1;
            const entry = {
                nom: p.practica_nom || '(Sin práctica/actividad asociada)',
                problema_nom: p.origen_tipo === 'PRACTICA' ? (p.practica_nom || `Práctica #${p.id_problema}`) : (p.problema_nom || `Ejercicio #${p.id_problema}`),
                aula_nom: p.aula_nom || '',
                isPractica: isPrac,
                origen_tipo: p.origen_tipo
            };
            if (isPrac) {
                practicas.push(entry);
            } else {
                actividades.push(entry);
            }
        }
    });

    const pildoras: { nombre: string; conjunt_nom: string; aula_nom: string }[] = [];
    (rewardsUsage?.cazas || []).forEach((c: any) => {
        let matches = false;
        if (type === 'javamon') {
            if (c.javamon === itemId || String(c.javamon) === String(itemId)) {
                matches = true;
            } else if (c.reward_type === 'JAVAMON' && (c.item_id === itemId || String(c.item_id) === String(itemId))) {
                matches = true;
            }
        } else {
            if (matchesType(type, c.reward_type) && (c.item_id === itemId || String(c.item_id) === String(itemId))) {
                matches = true;
            }
        }

        if (matches) {
            pildoras.push({
                nombre: c.nombre || `Píldora #${c.id}`,
                conjunt_nom: c.conjunt_nom || '',
                aula_nom: c.aula_nom || ''
            });
        }
    });

    const shopItems: { id: number; nom: string; cost: number; stock: number }[] = [];
    (rewardsUsage?.shop || []).forEach((s: any) => {
        let matches = false;
        if (type === 'javamon') {
            if ((s.type === 'JAVAmon' || s.type === 'javamon') && (s.id_game_item === itemId || String(s.id_game_item) === String(itemId) || s.id === itemId)) {
                matches = true;
            }
        } else {
            if (matchesType(type, s.type) && (s.id_game_item === itemId || String(s.id_game_item) === String(itemId))) {
                matches = true;
            }
        }

        if (matches) {
            shopItems.push({
                id: s.id,
                nom: s.nom,
                cost: s.cost,
                stock: s.stock
            });
        }
    });

    const botinesList: { botin_nom: string; botin_identifier: string }[] = [];
    (rewardsUsage?.botines || []).forEach((b: any) => {
        let matches = false;
        if (type === 'javamon') {
            if (b.tipo === 'JAVAMON' && (b.id_item === itemId || String(b.id_item) === String(itemId))) {
                matches = true;
            }
        } else {
            if (matchesType(type, b.tipo) && (b.id_item === itemId || String(b.id_item) === String(itemId))) {
                matches = true;
            }
        }

        if (matches) {
            botinesList.push({
                botin_nom: b.botin_nom,
                botin_identifier: b.botin_identifier
            });
        }
    });

    const totalSources = actividades.length + practicas.length + pildoras.length + shopItems.length + botinesList.length;
    const isObtainable = totalSources > 0;

    return {
        actividades,
        practicas,
        pildoras,
        shopItems,
        botinesList,
        totalSources,
        isObtainable
    };
};
